<template>
  <div>
    <div v-if="accesscheckk == true">
      <v-card class="pt-2 ma-2" max-width="100%" v-if="Show == false">
        <v-data-table
          dense
          class="elevation-1"
          :headers="headers"
          :items="ExpenseList"
          item-key="name"
          :options.sync="pagination"
          :no-data-text="Nodata"
          :items-per-page="itemsPerPage"
          @update:options="getExpenseApprDataPagination()"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ ExpenseList.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.user_detail`]="{ item }">
            <span class="caption"
              ><b>{{ item.user_detail.user_name }}</b></span
            >
            <br />
            <!-- </template>
         
        <template v-slot:[`item.mobile_no`]="{ item }"> -->
            <span class="caption">{{ item.user_detail.mobile_no }}</span>
          </template>
          <template v-slot:[`item.total_amount`]="{ item }">
            <span class="caption"
              >{{ item.currency }} {{ item.total_amount }}</span
            >
          </template>
          <template v-slot:[`item.request_type`]="{ item }">
            <span v-if="item.request_type != ''" class="caption">{{
              item.request_type
            }}</span>
            <span v-if="item.request_type == ''" class="caption">-</span>
          </template>

          <template v-slot:[`item.created_on`]="{ item }">
            <span class="caption">{{ item.created_on }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div v-if="item.status == '0' || item.status == '6'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PENDING
                  </span>
                </template>
                <span>Pending on Approver Level 1</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '1'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption green--text font-weight-medium"
                    >APPROVED</span
                  >
                </template>
                <span>Approved</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '2'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption red--text font-weight-medium"
                    >REJECTED</span
                  >
                </template>
                <span>rejected </span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '3'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption gold--text font-weight-medium"
                    >PARTIALLY APPROVED</span
                  >
                </template>
                <span> Partially Approved </span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '4'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PENDING
                  </span>
                </template>
                <span>pending on Approver Level 2</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '5'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption blue--text font-weight-medium"
                    >AMOUNT RECOVERED</span
                  >
                </template>
                <span>Amount Recovered</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="showContent(item)"
                  small
                  class="mr-2"
                  v-on="on"
                  color="primary"
                  >mdi-eye</v-icon
                >
              </template>
              <span>view details</span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-row class="ml-2 mt-1 mr-2">
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogStart"
                  v-model="modalStart"
                  :return-value.sync="start_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="start_date"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="start_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalStart = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogStart.save(start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEnd"
                  :return-value.sync="end_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="end_date"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <!-- <v-col lg="2">
                  <label class="caption">Status</label>
                  <v-select v-model="statusType" :items="statusList" dense solo label="Status"></v-select>
              </v-col>-->
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-text-field
                  dense
                  shaped
                  outlined
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  :hint="searchHint"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="1" xl="1" md="1" sm="12" xs="12">
                <v-btn
                  small
                  fab
                  text
                  color="primary"
                  class="elevation-0"
                  @click="getExpenseApprData()"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div v-if="accesscheckk == false" class="mt-16">
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </div>
    <div></div>
    <OverleyProccessg :overlay="overlay" />

    <!-- <ViewReceiptDetails
      ref="ViewReceiptDetails"
      v-on:backChild="callstatus()"
    /> -->
    <Viewreciept
      v-if="Show == true"
      :ExpenseList="ExpenseList"
      @backOn="callstatus()"
      :Approvertypecheck="Approvertypecheck"
      :expenseid="expenseid"
      :PropItem="PropItem"
    />
  </div>
</template>
<script>
// import ViewReceiptDetails from "@/components/ExpenseSubFol/ViewReceiptDetails.vue";/

//import ApproveViewDetailsCust from "@/components/CustomerSubfolder/ApproveViewDetailsCust.vue";
import Viewreciept from "@/components/ExpenseSubFol/Viewreciept.vue";

import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
    Viewreciept,

    // ViewReceiptDetails,
  },
  data: () => ({
    searchHint: "expense name",

    Show: false,
    accesscheckk: false,
    receiptStatus: false,
    checkdataaction: false,
    arraylistStatus: false,
    contentDialog: false,
    start_date: null,
    end_date: null,
    modalEnd: "",
    modalStart: "",
    workflowType: "Customer Onboarding",
    ExpenseList: [],
    headers: [
      { text: "SL NO", value: "sl_no" },
      // align: ' d-none'
      {
        text: "NAME",
        align: "start",
        sortable: false,
        value: "user_detail",
      },
      {
        text: "EXPENSE NAME",
        align: "start",
        sortable: false,
        value: "expense_name",
      },

      // {
      //   text: "Initiated On",
      //   value: "initiated_on",
      //   align: "start",
      //   sortable: false,
      // },
      {
        text: "AMOUNT",
        value: "total_amount",
        align: "start",
        sortable: false,
      },
      {
        text: "DATE & TIME",
        value: "created_on",
        align: "start",
        sortable: false,
      },

      {
        text: "APPEAL STATUS",
        value: "request_type",
        align: "start",
        sortable: false,
      },
      {
        text: "STATUS",
        value: "status",
        align: "start",
        sortable: false,
      },
      { text: "ACTION", value: "actions", align: "start", sortable: false },
    ],
    overlay: false,
    search: "",
    itemfield: "",
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    expenseid: "",
    PropItem: {},
    Approvertypecheck: "2",
    Nodata: "",
  }),
  mounted() {
    this.checkaccess();
    this.getcountNotification();
  },
  created() {
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.getExpenseApprData();
  },
  watch:{
    Show(val){
      if(val == true){
        this.$emit("Showvalue2", val);
       
      }else{
        this.$emit("Showvalue2", val );
      }
    }
  },
  methods: {
    callstatus() {
      this.Show = false;
      this.getExpenseApprData();
    },
    async getExpenseApprDataPagination() {
      if (this.ExpenseList.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "EXPENSE",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GETEXPAPPTWO",
            search_text: this.search,
            from_date: this.start_date,
            to_date: this.end_date,
            corp_id: this.$store.getters.get_corpid, // 0,,
            user_id: this.$store.getters.get_userid,
            //status: 0,
            // approver_type: "2",
            //status: 0,
          },
        };

        var responseData = await apiCall(inputData);

        this.ExpenseList = this.ExpenseList.concat(responseData.data.data);
      }
    },
    async getExpenseApprData() {
      this.overlay = true;
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "GETEXPAPPTWO",
          search_text: this.search,
          from_date: this.start_date,
          to_date: this.end_date,
          corp_id: this.$store.getters.get_corpid, // 0,,
          user_id: this.$store.getters.get_userid,
          //status: 0,
          // approver_type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("GETLIST", responseData.data.data);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.ExpenseList =
            responseData.data.data == null ? [] : responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.ExpenseList = [];
        this.overlay = false;
      }
      this.overlay = false;
    },
    async showContent(item) {
      this.overlay = true;
      // console.log("itemGEXPTXN", item);
      this.expenseid = item.expense_id;

      this.PropItem = item;

      this.Show = true;
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GEXPTXN",
          expense_id: item.expense_id,
          approver_type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.ExpenseList =
          responseData.data.data == null ? [] : responseData.data.data;
        this.checkdataaction = true;
      }

      this.overlay = false;
    },
    async checkaccess() {
      // alert(30);
      this.expandcheck = false;
      // this.$router.push("/accessdenied");
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "EXMGMT",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      //  console.log(responseData, "responsCHECK_ACCESSeData");
      var checkaccessdata = responseData.data.data;
      // checkaccessdata.is_approver = false;
      // checkaccessdata.is_checker = false;
      // checkaccessdata.is_maker = false;
      // checkaccessdata.is_viewer = false;
      if (
        checkaccessdata.is_checker == false &&
        checkaccessdata.is_approver == false &&
        checkaccessdata.is_maker == true &&
        checkaccessdata.is_viewer == true
      ) {
        this.accesscheckk = false;
      } else if (
        checkaccessdata.is_approver == true &&
        checkaccessdata.is_checker == false &&
        checkaccessdata.is_maker == true &&
        checkaccessdata.is_viewer == true
      ) {
        this.accesscheckk = true;
      } else if (
        checkaccessdata.is_approver == true &&
        checkaccessdata.is_checker == true &&
        checkaccessdata.is_maker == true &&
        checkaccessdata.is_viewer == true
      ) {
        this.accesscheckk = true;
      } else if (
        checkaccessdata.is_approver == false &&
        checkaccessdata.is_checker == false &&
        checkaccessdata.is_maker == false &&
        checkaccessdata.is_viewer == true
      ) {
        this.accesscheckk = true;
      } else {
        this.accesscheckk = false;
      }
    },
    getFileName(filename) {
      // console.log("vvv", filename);
      var url = filename.split("/");
      var len = url.length;
      const sample = url[len - 1];
      return sample;
    },
    convertDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);

      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            break;
        }
      }
    },
  },
};
</script>
